import { render, staticRenderFns } from "./LoggingListTable.vue?vue&type=template&id=2f0da3f6&"
import script from "./LoggingListTable.vue?vue&type=script&lang=js&"
export * from "./LoggingListTable.vue?vue&type=script&lang=js&"
import style0 from "./LoggingListTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports